export default "__VITE_ASSET__f038df00__"